<template>
	<div class="navigation-wrapper">
		<div class="navigation-logo navigation-logo-mobile">
			<NuxtLink
				class=""
				:to="localePath('/')"
				v-if="navigation.pages[0].fields.pageName === 'Home'"
			>
				<img :src="logo.file.url" :alt="logo.title" :width="logo.file.details.image.width" :height="logo.file.details.image.height" />
			</NuxtLink>
		</div>

		<div class="navigation-close-menu">
			<div class="menu mobile-menu">
				<label>
					<input type="checkbox" v-on:click.stop="toggleMenu">
					<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
						<path class="line--1" d="M0 70l28-28c2-2 2-2 7-2h64" />
						<path class="line--2" d="M0 50h99" />
						<path class="line--3" d="M0 30l28 28c2 2 2 2 7 2h64" />
					</svg>
				</label>
			</div>
		</div>

		<nav v-if="navigation">
			<div class="container">
				<div class="navigation-container">
					<div class="navigation-logo">
						<NuxtLink
							class=""
							:to="localePath('/')"
							v-if="navigation.pages[0].fields.pageName === 'Home'"
						>
							<img :src="logo.file.url" :alt="logo.title" :width="logo.file.details.image.width" :height="logo.file.details.image.height" />
						</NuxtLink>
					</div>
					<div class="navigation-links">
						<ul class="navigation-links-list">
							<li
								@mouseenter="prefetchByUrl(link.fields.slug)"
								v-for="link in navigationLinks"
								:key="link.sys.id"
							>
								<NuxtLink
									prefetch
									:to="localePath(`/${link.fields.slug.replace('/', '')}`)"
								>
									{{ link.fields.pageName }}
								</NuxtLink>
							</li>
							<li class="language-switcher">
								<LangSwitcher />
							</li>
						</ul>
					</div>

				</div>
			</div>
		</nav>
	</div>
</template>

<script setup>
const localePath = useLocalePath();
const { locale } = useI18n();

const prefetchByUrl = async (url) => {
	// Prefetch the route components
	await preloadRouteComponents(url);
};

const { data: navData } = await useFetch('/api/contentful/navigation', {
	query: {
		locale: `${locale.value}-CA`
	},
	key: `navigation-${locale.value}-CA`,
	watch: [locale] // Re-fetch when locale changes
});

const navigation = computed(() => {
	return navData?.value?.fields;
});

const navigationLinks = computed(() => {
	const pages = navigation.value?.pages;
	if (!pages) {
		return [];
	}

	return pages
		.filter(page => page.fields?.pageName !== 'Home')
		.map(page => ({
			...page,
			fields: {
				...page.fields,
				// Use redirectTo if it exists, otherwise use slug
				slug: page.fields?.redirectTo || page.fields?.slug
			}
		}));
});

const logo = computed(() => {
	const pages = navigation.value?.pages;

	if (!pages) {
		return null
	}

	const homePage = pages.find(page =>
		page.fields?.pageName === 'Home' ||
		page.fields?.slug === 'home'
	);

	return homePage?.fields?.image?.fields;
});

const toggleMenu = () => {
	if(window.innerWidth <= 1023) {
		document.body.classList.toggle('mobile-nav-is-open')
	}
};
</script>

<style lang="scss">
@use '~/assets/scss/components/Navigation.scss';
</style>
